import React from "react";
import { useForm } from "react-hook-form";

const Contact = () => {

    const inputStyle = "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";

    const {
        register,
        trigger,
        formState: { errors }
    } = useForm();

    const onSubmit = (e) => {
        const isValid = trigger();
        if (!isValid) {
            e.preventDefault();
        }
    }

    return (
        <div className="flex justify-center pt-12 md:pt-28 mb-20 md:mb-32 px-4 md:px-0" id="contact">
            <div className="container" data-aos="zoom-in-up">
                <h1 className="text-4xl mb-12 text-green-600 font-header">Contact Us</h1>
                <div className="flex flex-col md:flex-row">
                    <div className="md:w-2/3 md:mr-8 my-auto">
                        <div style={{ backgroundImage: `url(https://res.cloudinary.com/dkltotiq0/image/upload/v1675952320/banraas%2C%20gili-iyang/contact_easpje.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center center' }} className="w-full lg:h-[480px] rounded-2xl">
                        </div>
                    </div>
                    <div className="md:w-1/2 pt-4 md:pt-0 my-auto">
                        <div className="flex flex-col justify-start content-start">
                            {/* <h4 className="text-start text-xl mb-4"><span className="font-bold">To</span> : giliiyang_official@gmail.com</h4> */}
                            <form
                                target="_blank"
                                onSubmit={onSubmit}
                                method="POST"
                                action="https://formsubmit.co/giliiyang.official@gmail.com">
                                <div className="mb-3 xl:w-full text-start">
                                    <label htmlFor="exampleFormControlInput1" className="form-label inline-block mb-2 text-gray-700">
                                        Email
                                    </label>
                                    <input
                                        type="text"
                                        className={inputStyle}
                                        id="exampleFormControlInput1"
                                        placeholder="Tulis email anda disini"
                                        {...register("email", {
                                            required: true,
                                            // maxLength: 200
                                            pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        })}
                                    />
                                    {
                                        errors.email && (
                                            <p className="mt-1 text-red-600">
                                                {errors.email.type === "required" && "This field is required."}
                                                {errors.email.type === "pettern" && "invalid email address."}
                                            </p>
                                        )
                                    }
                                </div>
                                <div className="mb-3 xl:w-full text-start">
                                    <label htmlFor="exampleFormControlInput1" className="form-label inline-block mb-2 text-gray-700">
                                        Subjek
                                    </label>
                                    <input
                                        type="text"
                                        className={inputStyle}
                                        id="exampleFormControlInput1"
                                        placeholder="Tulis subjek anda disini"
                                        {...register("subjek", {
                                            required: true,
                                            maxLength: 200
                                        })}
                                    />
                                    {
                                        errors.subjek && (
                                            <p className="mt-1 text-red-600">
                                                {errors.subjek.type === "required" && "This field is required."}
                                                {errors.subjek.type === "maxLength" && "Max length is 200 char."}
                                            </p>
                                        )
                                    }
                                </div>
                                <div className="mb-3 xl:w-full text-start">
                                    <label htmlFor="exampleFormControlInput1" className="form-label inline-block mb-2 text-gray-700">
                                        Pesan
                                    </label>
                                    <textarea
                                        type="text"
                                        className={`${inputStyle} h-[75px]`}
                                        id="exampleFormControlInput1"
                                        placeholder="Tulis Pesan Anda disini"
                                        {...register("pesan", {
                                            required: true,
                                            maxLength: 2000,

                                        })}
                                    />
                                    {errors.pesan && (
                                        <p className="mt-1 text-red-600">
                                            {errors.pesan.type === "required" && "This field is required."}
                                            {errors.pesan.type === "maxLength" && "Max length is 2000 char."}
                                        </p>
                                    )}
                                </div>
                                <button type="submit" className="my-4 w-full bg-blue-700 p-3 rounded-lg font-bold text-white hover:bg-blue-600 transition delay-100">
                                    Send
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;